export default {
    'warehouses-statistics': 'Warehouses Statistics',
    'materials-statement': 'Materials statement',
    'material-stock-limit': 'Material stock limit',
    'materials-stock-by-city-statistics': 'Material stock',
}